module.exports = __webpack_public_path__ + "static/media/AvatarLelio.be2df16b.png";